<template>
	<div class="wrapper">
		<!-- 图片 -->
		<div class="banner">
			<div class="banner-one">
				<img @mousemove="move" @mouseleave="leave" class="card" style="width: 23%;"
					src="../../assets/img/home/1.png" alt="" />
				<img @mousemove="move2" @mouseleave="leave2" class="card2" style="width: 42%;"
					src="../../assets/img/home/2.png" alt="" />
				<div style="display: flex;flex-direction: column;width: 35%;">
					<img @mousemove="move3" @mouseleave="leave3" class="card3" src="../../assets/img/home/3.png"
						alt="" />
					<div style="display: flex">
						<img style="width: 40%;" src="../../assets/img/home/logo.png" alt="" />
						<img @mousemove="move7" @mouseleave="leave7" class="card7" style="width: 60%;"
							src="../../assets/img/home/7.png" alt="" />
					</div>
				</div>
			</div>
			<div class="banner-one">
				<img @mousemove="move4" @mouseleave="leave4" class="card4" style="width: 30%;"
					src="../../assets/img/home/4.png" alt="" />
				<img @mousemove="move5" @mouseleave="leave5" class="card5" style="width: 47%;"
					src="../../assets/img/home/5.png" alt="" />
				<img @mousemove="move6" @mouseleave="leave6" class="card6" style="width: 24%;"
					src="../../assets/img/home/6.png" alt="" />
			</div>
		</div>
		<!-- 第二部分 -->
		
	<!-- 动画 -->
	  <!-- v4之后的版本class名格式为: "animate__animated animate__fadeIn" ,得加上 "animate__" 前缀 class="box animate__animated animate__zoomIn" -->
		<!-- <div class="ty">
		
			<div :class="[oneanimate==true?'box animate__animated animate__fadeInDown':'displaynonestyle']">
				<h1 style="color:red;font-size:30px">12343</h1>
				</div>
		</div> -->
		<div class="ty" ref="animateFadein">
		<div :class="[animateFadein==true?'box animate__animated animate__fadeIn':'displaynonestyle']">
		<div class="part-item-detail">
			<div class="part-item-detail-A">
			<div class="items">
				<div class="part-item-detail-one">
					<img src="../../assets/img/aboutUs/1.png" alt=""  class="part-item-detail-one-img"/>
				<div class="part-item-detail-two">
				<h1 class="wz">#1 Socks & Pantyhose</h1>
				<h1 class="wz">manufacturer & exporter in the world</h1>
				</div>
				
				</div>
				<div style="padding-left: 80px;">
				<el-divider></el-divider>
				</div>
			</div>
			
			<div class="items">
				<div class="part-item-detail-one">
					<img src="../../assets/img/aboutUs/2.png" alt=""  class="part-item-detail-one-img"/>
				<div class="part-item-detail-two">
				<h1 class="wz">2.1 billion pairs</h1>
				</div>
				
				</div>
				<div style="padding-left: 80px;">
				<el-divider></el-divider>
				</div>
			</div>
			
			
			<div class="items"> 
				<div class="part-item-detail-one">
					<img src="../../assets/img/aboutUs/3.png" alt=""  class="part-item-detail-one-img"/>
				<div class="part-item-detail-two">
				<h1 class="wz">Global design offices in Tokyo,</h1>
				<h1 class="wz">NYC, London and North Carolina</h1>
				</div>
				
				</div>
				<!-- <el-divider></el-divider> -->
			</div>
			</div>
			
			<div class="part-item-detail-B">
				<div class="img-wrapper">
					<img class="imgsize" src="../../assets/img/aboutUs/topimg1.png" alt="" />
					</div>
			</div>
			
		</div>
		</div>
			
		</div>
		
		
		
		
		
		
		<!-- 第三部分 -->
		
		
				
				
				<div class="part-two">
					<h1 class="wzsize">WHY ASIA SOCKS APPAREL?</h1>
					<h1 class="wzsize">30+ Years Of Development History,15 Production Plants</h1>
				
				  <!-- v4之后的版本class名格式为: "animate__animated animate__fadeIn" ,得加上 "animate__" 前缀 class="box animate__animated animate__zoomIn" -->
				  <div class="ty" ref="oneanimate">
					<div :class="[oneanimate==true?'box animate__animated animate__fadeInDown':'displaynonestyle']">
					<div class="part-two-item">
						<!-- v-for循环遍历 -->
						<div class="part-two-item-detail" v-for="(item,index) in partTwoItem" :key="item.id">
							<h1 class="part-two-item-title">{{item.title}}</h1>
							<h1 class="part-two-item-content" :class="{'part-two-item-content-active':item.id==hoverIndex}"
								@mouseover="hoverIndex=item.id" @mouseleave="hoverIndex = -1">{{item.content}}</h1>
							<div class="bkstyle" :class="{'bkstyle-active':item.id==hoverIndex}" @mouseover="hoverIndex=item.id"
								@mouseleave="hoverIndex = -1" @click="buttonItem(item.id)">
								<span>{{item.buttontext}}</span>
							</div>
						</div>
					</div>
					
					
				</div>
				
				
				
				</div>
		</div>
		
		
	<!-- 第四部分 -->
		<!-- body C -->
		<div>
		<div class="body-c-wrapper" ref="twoanimate">
			
			<img class="body-c-img" src="../../assets/img/home/Body C.png" alt=""  />
		
			<div class="body-c-content">
				<div class="ty">
									<div :class="[twoanimate==true?'box animate__animated  animate__bounceInRight':'displaynonestyle']">
				
				<i class="iconfont icon-shuangyinhao"></i>
				<h1 class="body-c-content-item-one">社会责任</h1>
				<h1 class="body-c-content-item-two">在和谐共生理念的推动下，人们将秉持“相互依存、共生互利、需求互补、协同进化、美
美与共”的态度，用先进科技融合自然理念，诠释全新的时尚精髓，促进人类与自然的和
谐共生，携手共建一个更加包容、绿色和智能的美好未来</h1>
<h1 class="body-c-content-item-three">Under the guidance of the concept of harmonious coexistence, people will 
adhere to the attitude of "interdependence, symbiosis, complementary needs, 
collaborative evolution, and beauty for all," using advanced technology to 
integrate natural concepts, interpreting a new essence of fashion, and 
promoting the harmonious coexistence of humanity and nature.  Together, 
we will build a more inclusive, green, and intelligent future</h1>
<i class="iconfont icon-shuangyinhao1"></i>
			</div>
			
			</div>	
			</div>	
		</div>	
		
		<div class="body-c-wrapper" ref="threeanimate">
					
					<img class="body-c-img" src="../../assets/img/home/Body D.png" alt=""  />
				
					<div class="body-d-content">
						<div class="ty" >
											<div :class="[threeanimate==true?'box animate__animated  animate__bounceIn':'displaynonestyle']">
						
						
						<i class="iconfont icon-shuangyinhao"></i>
						<h1 class="body-c-content-item-one">公益慈善</h1>
						<h1 class="body-c-content-item-two">常年资助捐款，承担企业应有的社会责任感。</h1>
		<h1 class="body-c-content-item-three">We make donations throughout the 
year and shoulder the social responsibility that a company should have.</h1>
		<i class="iconfont icon-shuangyinhao1"></i>
					</div>
				</div>	
		</div>
		</div>	
		
		<div class="body-c-wrapper" ref="fouranimate">
					<div>
					<img class="body-c-img" src="../../assets/img/home/Body E.png" alt=""  />
					</div>
					<div class="body-e-content">
						<div class="ty" >
											<div :class="[fouranimate==true?'box animate__animated  animate__bounceInLeft':'displaynonestyle']">
						<i class="iconfont icon-shuangyinhao"></i>
						<h1 class="body-c-content-item-one">环保自然</h1>
						<h1 class="body-c-content-item-two">随着可持续理念深入人心，人们对天然纺织品的传统工艺不断反思，逐步探索新技术方
向以及生物技术领域的应用。</h1>
		<h1 class="body-c-content-item-three">With the concept of sustainability deeply taking 
root, people are constantly reviewing on the traditional process of natural 
textiles, and gradually exploring the directions of new technologies and 
applications in the field of biotechnology.</h1>
		<i class="iconfont icon-shuangyinhao1"></i>
					</div>
				</div>	
		</div>
		</div>
		</div>	
		
		<!-- brands -->
		<div class="brands-wrapper">
			<div class="brands-title">
				COOPERATING BRANDS
			</div>
			<div style="padding: 20px 60px;font-weight: bold">
			 <el-divider></el-divider>
			 </div>
			 
			 <div class="ty" ref="fiveanimate">
			 					<div :class="[fiveanimate==true?'box animate__animated  animate__lightSpeedInRight':'displaynonestyle']">
			 
			<div class="brands-item">
			<div 
			class="brands-item-img"
			v-for="(item,index) in brandsItem"
			:key="item.id">
			<div style="background-color: #232222;width: :300px;height: 150px;display: flex;align-items: center;justify-content: center;">
				<img :src="item.img_url" alt="" @click="goPartners"  class="brands-item-img-size"/>	
				</div>
			</div>
			</div>
			
			</div>
			</div>
			
			
		</div>
		
		<!-- contact us -->
		<div  ref="sixanimate">
			<div style="position: relative;">
			<img src="../../assets/img/home/home-contact us.png" alt="" width="100%"/>
			<div class="wzstyle">
				<div class="ty" >
									<div :class="[sixanimate==true?'box animate__animated  animate__zoomInDown':'displaynonestyle']">
				<div class="wzstyle-one">
				<h1 class="wzstyle-two">CONTACT US TO REACH OUR SALES DEPARTMENT. </h1>
                <h1 class="wzstyle-two">WE LOOK FORWARD TO HEARING FROM YOU</h1>
                </div>
				   </div>
				      </div>
		<div style="display: flex;align-items: center">
<el-button type="primary" plain @click="to">
	 Contact us
	</el-button>
</div>		
			</div>
			
			</div>
		</div>
		
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				animateFadein:false,
				oneanimate:false,
				twoanimate:false,
				threeanimate:false,
				fouranimate:false,
				fiveanimate:false,
				sixanimate:false,
				hoverIndex: -1,
				partTwoItem: [{
						id: 1,
						title: '东华大学合作研究所-东华·中吴针织服饰时尚创新中心',
						content: `东华大学上海国际时尚科创中心与上海中吴针织有限公司本着强强联合、优势互补、资
源共享、互惠双赢、共同发展的原则，双方各自发挥在行业资源、专业领域、研究成
果、人才培养等方面优势，共建“东华·中吴针织服饰时尚创新中心”。`,
						buttontext: 'Learn more'
					},
					{
						id: 2,
						title: '伦敦设计中心',
						content: `位于东京、纽约、伦敦和北卡罗来纳州的全球设计办公室。在柬埔寨、埃塞俄比亚和缅
甸建立新的制造工厂，扩大生产和运营。品牌产品包含导电按摩袜、脚护美容袜、SPA
手套……`,
						buttontext: 'Learn more'
					},
					{
						id: 3,
						title: '全链路产业链',
						content: `YARN-KNITTING-SEWING-BOARDING-INSPECTION-PAIRING。中国第一大袜子
制造商和出口商。3,700 名员工，每月袜子产量高达 3000 万双。上海仓库 1,300,000 
平方英尺。`,
						buttontext: 'Learn more'
					},
					{
						id: 4,
						title: '公益事业',
						content: `常年资助捐款，承担企业应有的社会责任感。环保公益，研发低碳环保技术：天然纺织
品生态加工、再生纤维素纤维、循环利用、生物可降解、植物基、负碳纺织品 、低碳染
色 、微生物技术……`,
						buttontext: 'Learn more'
					}
				],
				brandsItem:[
					{id:1,img_url:require('../../assets/img/home/brands4.png')},
					{id:2,img_url:require('../../assets/img/home/brands1.png')},
					{id:3,img_url:require('../../assets/img/home/brands3.png')},
					{id:4,img_url:require('../../assets/img/home/brands2-1.png')},
					{id:5,img_url:require('../../assets/img/home/brands5.png')},
					{id:6,img_url:require('../../assets/img/home/brands6.png')},
					{id:7,img_url:require('../../assets/img/home/brands7.png')},
					{id:8,img_url:require('../../assets/img/home/brands8-1.png')}
				]
			}
		},
		mounted() {
			 window.addEventListener('scroll', this.watchScroll)
			
			
		},
		// 滚动重置
		    	beforeDestroy () {
		      		window.removeEventListener('scroll', this.watchScroll)
		    	},
		created() {},
		methods: {
			//监听页面滚动，然后做判断
			watchScroll () {
			
			           let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
						
			        //console.log(scrollTop)
					if(scrollTop >= this.$refs.animateFadein.offsetTop-300){//当前滚动位置到达testref的时候，显示div（100作为调整用）
						 this.animateFadein = true;
					}
			        if (scrollTop >= this.$refs.oneanimate.offsetTop-300) { 
			        this.oneanimate = true;
			              }
					if (scrollTop >=this.$refs.twoanimate.offsetTop-300) { 
				 this.twoanimate = true;
					    }
					if (scrollTop >= this.$refs.threeanimate.offsetTop-300) {
							     this.threeanimate = true;
							      }	 
					if (scrollTop >= this.$refs.fouranimate.offsetTop-300) {
								     this.fouranimate = true;
								      }
					if (scrollTop >= this.$refs.fiveanimate.offsetTop-300) {
										   			     this.fiveanimate = true;
										   			      }
					if (scrollTop >= (this.$refs.sixanimate.offsetTop - 700) ) {
						this.sixanimate = true;
						}	
				
			        },
			
			
			
			//首页图片js效果
			move(e) {
				const card = document.querySelector(".card");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave(e) {
				const card = document.querySelector(".card");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move2(e) {
				const card = document.querySelector(".card2");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave2(e) {
				const card = document.querySelector(".card2");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move3(e) {
				const card = document.querySelector(".card3");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave3(e) {
				const card = document.querySelector(".card3");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move4(e) {
				const card = document.querySelector(".card4");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave4(e) {
				const card = document.querySelector(".card4");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move5(e) {
				const card = document.querySelector(".card5");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave5(e) {
				const card = document.querySelector(".card5");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move6(e) {
				const card = document.querySelector(".card6");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave6(e) {
				const card = document.querySelector(".card6");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			move7(e) {
				const card = document.querySelector(".card7");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = card.offsetLeft + cardWidth / 2;
				const centerY = card.offsetTop + cardHeight / 2;
				const mouseX = e.clientX - centerX;
				const mouseY = e.clientY - centerY;
				const rotateX = (angle * mouseY) / (cardHeight / 2);
				const rotateY = (-angle * mouseX) / (cardWidth / 2);

				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			leave7(e) {
				const card = document.querySelector(".card7");
				const angle = 20;
				const cardWidth = card.offsetWidth;
				const cardHeight = card.offsetHeight;
				const centerX = 0;
				const centerY = 0;
				const mouseX = 0;
				const mouseY = 0;
				const rotateX = 0;
				const rotateY = 0;
				card.style.setProperty("--rotateX", rotateX + "deg");
				card.style.setProperty("--rotateY", rotateY + "deg");
			},
			
			
			to(){
				this.$router.push({name:'contact'})
			},
			buttonItem(id){
				console.log(id)
				if(id == 1){
					this.$router.push({name:'trends'})
				}else if(id == 2){
					this.$router.push({name:'design'})
				}else if(id == 3){
					this.$router.push({name:'chain'})
				}else if(id == 4){
					this.$router.push({name:'givingback'})
				}
			},
			goPartners(){
				this.$router.push({name:'partners'})
			},
			// handleScroll(e) {
			//   const scrollTop = this.$refs.app.scrollTop
			//   console.log(scrollTop)
			// },
			
			













		}
	}
</script>

<style lang="scss" scoped>
	// 使用在线iconfont图标资源
	@import url(//at.alicdn.com/t/c/font_4623761_z2vkj727vlc.css);
	.wrapper {
		width: 100%;
		background-color: #000000;

	}

	.banner {
		height: 100%;
	}

	.banner-one {
		display: flex;
		justify-content: space-between;
	}

	.card,
	.card2,
	.card3,
	.card4,
	.card5,
	.card6,
	.card7 {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		transform: perspective(1200px) rotateX(var(--rotateX, 0)) rotateY(var(--rotateY, 0));
		transition: all 100ms ease;
	}


	
// 	//媒体查询	
//电脑端
//最小屏幕宽度，大于1100px
@media screen and (min-width: 1100px) {
	.part-item-detail{
		padding: 150px 20px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.part-item-detail-one{
		display: flex;
		justify-content: space-between;
	}
	.part-item-detail-two{
	display: flex;
	flex-direction: column;
	font-size: 25px;
	color:#FFE3AC;	
	}
	.wz{
		padding: 3px 0;
		font-weight: bold;
	}
	.imgsize{
		 width: 500px;
		height: 400px;
	}
	
	.img-wrapper{
		display: flex;
		justify-content: center;
	}
	.part-item-detail-A{
		width: 55%;
		padding: 0 50px;
		height: 400px;
		display: flex;
		//垂直排列
		flex-flow: column; 
		//两端对齐
		justify-content: space-between; 
	}
	.part-item-detail-B{
		width: 45%;
		height: 400px;
		display: flex;
		//垂直排列
		flex-flow: column; 
		//两端对齐
		justify-content: space-between; 
	}

//第三部分
.part-two {
		padding: 150px 0px 150px 40px;
		//height:1000px
	}

	.wzsize {
		font-size: 40px;
		padding: 10px 0;
		color: white;
	}
.part-two-item {
		padding: 30px 0;
		display: flex;
		flex-wrap: wrap;
		//justify-content: space-between;
	}

	.part-two-item-detail {
		width: 50%;
		padding: 0 80px 0 0;
	}

	.part-two-item-title {
		padding: 20px 0;
		font-size: 20px;
		color: #FFE3AC;
		font-weight: bold;
	}

	.part-two-item-content {
		height: 160px;
		padding: 20px 0 40px 0;
		font-size: 15px;
		color: #CBCBCB;
		line-height: 30px;
	}

	.part-two-item-content-active {
		height: 160px;
		padding: 20px 0 40px 0;
		font-size: 15px;
		color: #409EFF;
		line-height: 30px;
	}

	.bkstyle {
		border: 2px solid white;
		text-align: center;
		width: 25%;
		border-radius: 7px;
		color: white;
		padding: 10px 15px;
	}

	.bkstyle-active {
		border: 2px solid #FFE3AC;
		color: #000000;
		background-color: #FFE3AC;
		text-align: center;
		width: 25%;
		border-radius: 7px;
		padding: 10px 15px;
	}
//第四部分
.body-c-wrapper{
	position: relative;
	margin: -4px;
}	
.body-c-img{
	width: 100%;
	z-index: -100px;
}	
.body-c-content{
z-index:200;
	width: 550px;
	position: absolute;
	left:85%;
	top:50%;
	transform: translate(-85%,-50%);
	height:400px

}
.body-d-content{
	z-index:200;
	width: 550px;
	position: absolute;
	left:40%;
	top:50%;
	transform: translate(-40%,-50%)
}
.body-e-content{
	width: 550px;
	position: absolute;
	left:10%;
	top:50%;
	transform: translate(-10%,-50%)
}
.iconfont.icon-shuangyinhao{
	color:#FFE3AC;
	font-size: 35px;
}
.icon-shuangyinhao1{
	color:#FFE3AC;
	font-size: 35px;
	float: right;
}
.body-c-content-item-one{
	padding: 10px 0;
	color:#FFE3AC ;
	font-size: 20px;
}
.body-c-content-item-two{
	padding: 10px 0;
	color:white;
	font-size: 16px;
	line-height: 30px;
}
.body-c-content-item-three{
	padding: 10px 0;
	color:#99C1DA;
	font-size: 16px;
	line-height: 30px;
}
//第五部分
.brands-wrapper{
	padding: 100px 15px;
	//height:700px
}
.brands-title{
	text-align: center;
	font-size: 40px;
	color:#FFE3AC;
}
.el-divider--horizontal{
	height: 2px;
}
.brands-item{
	display: flex;
	flex-wrap: wrap;
	justify-items: center;
	
}
.brands-item-img{
	padding: 20px;
	width: 25%;
	//align-content: center;//垂直居中
	
}
.wzstyle{
	width: 80%;
	display: flex;
	justify-content: space-between;
	position: absolute;
	left:50%;
	top:50%;
	transform: translate(-50%,-50%)
	
	}
	.wzstyle-one{
	display: flex;
	flex-direction: column;	
	font-size: 30px;
	}
	.wzstyle-two{
		padding: 5px 0;
		color: #000000;
	}
	
 
}
//手机端
@media screen and (max-width: 1100px) {
 .part-item-detail{
 	padding: 50px 20px;
 	display: flex;
 	flex-direction: column;
 }
 .part-item-detail-one{
 	display: flex;
 	justify-content: space-between;
	
 }
 
  .part-item-detail-one-img{
 	width: 35px;
 	height: 35px;
 }
 .part-item-detail-two{
 display: flex;
 flex-direction: column;
 font-size: 12px;
 color:#FFE3AC;	
 }
 .wz{
 	padding: 3px 0;
 	font-weight: bold;
 }
 .imgsize{
 	 	width: 100%;
 }
 
 .img-wrapper{
 	display: flex;
 	justify-content: center;
 }
 .part-item-detail-A{
 	//两端对齐
 	justify-content: space-between; 
 }
 .part-item-detail-B{
 
	padding: 30px 0;
 }
 
 
 //第三部分
 .part-two {
 		padding: 30px 0px 30px 40px;
 		//height:1100px
		//height: 100%;
 	}
 
 	.wzsize {
 		font-size: 20px;
 		padding: 10px 0;
 		color: white;
 	}
 .part-two-item {
 		padding: 30px 0;
 		display: flex;
 		flex-direction: column;
 		//justify-content: space-between;
 	}
 
 	.part-two-item-detail {
 		//width: 50%;
 		padding: 0 80px 0 0;
 	}
 
 	.part-two-item-title {
 		padding: 20px 0;
 		font-size: 12px;
 		color: #FFE3AC;
 		font-weight: bold;
 	}
 
 	.part-two-item-content {
 		padding: 20px 0 40px 0;
 		font-size: 12px;
 		color: #CBCBCB;
 		line-height: 30px;
 	}
 
 	.part-two-item-content-active {
 		padding: 20px 0 40px 0;
 		font-size: 12px;
 		color: #409EFF;
 		line-height: 30px;
 	}
 
 	.bkstyle {
 		border: 2px solid white;
 		text-align: center;
 		border-radius: 7px;
 		color: white;
 		padding: 10px 15px;
 	}
 
 	.bkstyle-active {
 		border: 2px solid #FFE3AC;
 		color: #000000;
 		background-color: #FFE3AC;
 		text-align: center;
 		border-radius: 7px;
 		padding: 10px 15px;
 	}
//第四部分
.body-c-wrapper{
	position: relative;
	margin: -4px;
}	
.body-c-img{
	width: 100%;
	height: 100%;
	z-index: -100px;
}	
.body-c-content,.body-d-content,.body-e-content{
	width: 80%;
    z-index:200;
	position: absolute;
	left:50%;
	top:50%;
	transform: translate(-50%,-50%);
	// height:400px

}

.iconfont.icon-shuangyinhao{
	color:#FFE3AC;
	font-size: 12px;
}
.icon-shuangyinhao1{
	color:#FFE3AC;
	font-size: 12px;
	float: right;
}
.body-c-content-item-one{
	color:#FFE3AC ;
	font-size: 15px;
}
.body-c-content-item-two{
	color:white;
	font-size: 12px;
}
.body-c-content-item-three{
	display: none;

	color:#99C1DA;
	font-size: 12px;
}
 //第五部分
 .brands-wrapper{
 	padding: 100px 15px;
 	//height:700px
 }
 .brands-title{
 	text-align: center;
 	font-size: 20px;
 	color:#FFE3AC;
 }
 .el-divider--horizontal{
 	height: 2px;
 }
 .brands-item{
 	display: flex;
 	flex-wrap: wrap;
 	justify-items: center;
 	
 }
 .brands-item-img{
 	padding: 20px;
 	width: 50%;
 	//align-content: center;//垂直居中
 	
 }
 .brands-item-img-size{
	width: 100px;
	height: 15px;
	text-align: center;
	//align-content: center
 }
 .wzstyle{
 	width: 90%;
 	display: flex;
 	justify-content: space-between;
 	position: absolute;
 	left:50%;
 	top:50%;
 	transform: translate(-50%,-50%)
 	
 	}
 	.wzstyle-one{
 	display: flex;
 	flex-direction: column;	
 	font-size: 12px;
 	}
 	.wzstyle-two{
		
 		padding: 1px 0;
 		color: #000000;
 	}
 
 
}


	
	
	
	#detailContrainer {
	            position: absolute;
	            left: 0;
	            top: 0;
	            z-index: 100;
	            width: 100%;
	            min-height: 100%;
	            background: white;
	        }
	
	        #detailContrainer.slide-enter-active {
	            animation: .9s bounceInDown;
	        }
	
	        @keyframes bounceInDown {
	            0% {
	                transform: translateX(100%);
	            }
	            100% {
	                transform: translateX(0);
	            }
	        }
	
	        #content.contentDetail {
	            display: block;
	            margin-bottom: 0;
	        }
	
	
	//让元素透明度隐藏
	.displaynonestyle{
		 opacity: 0;
	}
	
	
</style>